import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfd7b914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "loading-cover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-name" }, "文件", -1))

import { ImagePreview, Loading } from 'vant'
import { Ref, ref, withDefaults, watch } from 'vue'
import { useImageGuidTransfer } from '@/compositions/common'
import fileSvg from '@/assets/file.svg'
import { Dialog } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonFilePreView',
  props: {
    guids: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { guids: string[] };


const imgSuffix = [
  'bmp',
  'jpg',
  'png',
  'tif',
  'gif',
  'pcx',
  'tga',
  'exif',
  'fpx',
  'svg',
  'psd',
  'cdr',
  'pcd',
  'dxf',
  'ufo',
  'eps',
  'ai',
  'raw',
  'wmf',
  'jpeg',
]
const { getImageFullUrl } = useImageGuidTransfer()
const imgLoading = ref(false)
const imageList: Ref<
  Array<{
    url: string
    isImg: boolean
  }>
> = ref([])

watch(
  () => props.guids,
  () => {
    imageList.value = props.guids.map((item) => ({
      url: '',
      isImg: false,
    }))
    initImageList()
  },
  {
    immediate: true,
  }
)
function imagePreviewHandler(index: number) {
  ImagePreview({
    images: imageList.value.map((item) => item.url),
    startPosition: index,
  })
}

async function initImageList() {
  imgLoading.value = true
  try {
    const data = await getImageFullUrl(props.guids)
    console.log('data', data)
    imageList.value = props.guids.map((guid) => {
      let fileName = data[guid].url.split('/').pop().split('?')[0]
      let isImg = false
      let suffix = fileName.split('.')[1]
      if (suffix) {
        isImg = !!imgSuffix.includes(suffix.toLowerCase())
      }
      console.log('isImg', isImg)
      return {
        url: data[guid].url,
        isImg,
      }
    })
  } catch (error) {
    console.log('error', error)
  }
  imgLoading.value = false
}

function fileClickHandle() {
  Dialog.alert({
    title: '提示',
    message: '暂不支持手机预览文件格式',
    confirmButtonColor: 'rgba(0, 195, 120, 1)',
    confirmButtonText: '知道了',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (imgLoading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(Loading))
            ]))
          : _createCommentVNode("", true),
        (item.isImg)
          ? _withDirectives((_openBlock(), _createElementBlock("img", {
              key: 1,
              src: item.url,
              alt: "",
              onClick: ($event: any) => (imagePreviewHandler(index))
            }, null, 8, _hoisted_4)), [
              [_vShow, !imgLoading.value]
            ])
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "file-wrap",
              onClick: fileClickHandle
            }, [
              _createElementVNode("img", {
                class: "file-img",
                src: _unref(fileSvg),
                width: "37",
                height: "47",
                style: {"margin-top":"10px","margin-bottom":"2px"}
              }, null, 8, _hoisted_5),
              _hoisted_6
            ]))
      ]))
    }), 128))
  ]))
}
}

})